import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import { transform } from "ol/proj";

import SisModal from "store/sis/sisModal";
import SisPagination from "store/sis/component/SisPagination";

import stl from "./MapInfoModal.module.scss";
import { bindActionCreators } from "redux";

//import lodash from "lodash";

class MapInfoModal extends Component {
	state = {
		tabCondition: [true, false, false, false, false, false],
		pagination: <SisPagination />,
		toji: {}, // 토지대장
		building: {}, // 건축물대장
		landUsePlan: [], // 토지이용계획
		individualPrice: [], // 개별공시지가
		individualHousePrice: [], // 개별주택가격
		addr: "", // 소재지
	};

	handleTabMove = (target) => {
		let tabCondition = [false, false, false, false, false, false];
		tabCondition[target] = true;
		this.setState({
			tabCondition: tabCondition,
		});
	};

	show = (coordinate, pnu = "", props = {}, init = false) => {
		const { sisMap, sisLayer } = this.props.sis;
		const self = this;

		$("#laws").html("");

		sisLayer.wfs.selectLayer.getSource().clear();

		//const view = sisMap.view;
		//const zoom = view.getZoom();
		//const coordinate = sisMap.contextClickCoord;

		// 우 클릭한 지점을 중심으로 이동
		// view.setCenter(coordinate);ls

		// 우클릭한 지점 pnu 찾기
		if (!pnu) {
			pnu = this.selectedItem(coordinate);

			this.setState({
				pnu,
			});
		} else {
			let addr = props.sggNm + " " + props.emdNm + " " + (props.riNm ? props.riNm : "") + " " + props.jibun;
			addr = addr.slice(0, -1);
			const addrToji = props.sggNm + " " + props.emdNm + " " + (props.riNm ? props.riNm : "");
			const jibun = parseInt(props.bobn) + (parseInt(props.bubn) > 0 ? `-${parseInt(props.bubn)}` : "");

			this.setState({
				addr,
				addrToji,
				jibun,
				pnu,
			});

			if (init) this.selectJijukByCode(pnu);
		}

		// 토지대장
		$.ajax({
			url: "/map/prop/getRecordRegister",
			data: { pnu },
			success: (res) => {
				if (res.length === 0) {
					// self.modal.close();
					// alert("지번정보가 존재하지 않습니다.");
				}

				self.setState({
					toji: res.length > 0 ? res[0] : {},
				});
			},
		});

		// 건축물 대장
		$.ajax({
			url: "/map/prop/getBuildingCommInfor",
			data: { pnu },
			success: (res) => {
				let data = "";

				if (res.length > 0) {
					data = res[0];

					$.each(res, (idx, item) => {
						if (item.MAIN_SUB_GBN_NM === "주건축물") data = item;
					});
				}

				self.setState({
					building: res.length > 0 ? data : {},
				});
			},
			error: (e) => {
				// console.log("건축물 대장");
				// console.log(e);
			},
		});

		// 토지이용계획
		$.ajax({
			url: "/map/prop/getLandUsePlan",
			data: { pnu },
			success: (res) => {
				// console.log("토지이용계획");
				// console.log(res);
				self.setState({
					landUsePlan: res.length > 0 ? res : [],
				});
			},
			error: (e) => {
				// console.log("토지이용계획");
				// console.log(e);
			},
		});
		var pnuTmp = pnu.replace("12210", "29110").replace("12240", "29140").replace("12270", "29155").replace("12300", "29170").replace("12330", "29200");
		// 개별공시지가
		$.ajax({
			// url: "/map/prop/getIndividualPrice",
			url: "https://api.vworld.kr/ned/data/getIndvdLandPriceAttr",
			type: "post",
			dataType: "jsonp",
			data: {
				pnu: pnuTmp,
				numOfRows: "100",
				//key: "0738BFC5-91AA-3D4C-879E-7DECA4530139"
				//key: "FE9D6FCF-D095-3C30-99E0-DB587D3BFF41"
				key: "22ACAE3E-B16B-34F6-8078-5FB44F80FA5E",
				domain: "https://gis.jeonnam-gwangju.go.kr"
			},
			success: (res) => {
				self.setState({
					individualPrice: res.indvdLandPrices ? res.indvdLandPrices.field : [],
				});
			},
		});

		// 개별주택가격
		$.ajax({
			// url: "/map/prop/getIndividualHousePrice",
			url: "https://api.vworld.kr/ned/data/getIndvdHousingPriceAttr",
			type: "post",
			dataType: "jsonp",
			data: {
				pnu: pnuTmp,
				numOfRows: "100",
				//key: "0738BFC5-91AA-3D4C-879E-7DECA4530139"
				//key: "FE9D6FCF-D095-3C30-99E0-DB587D3BFF41"
				key: "22ACAE3E-B16B-34F6-8078-5FB44F80FA5E",
				domain: "https://gis.jeonnam-gwangju.go.kr"
			},
			success: (res) => {
				self.setState({
					individualHousePrice: res.indvdHousingPrices ? res.indvdHousingPrices.field : [],
				});
			},
		});
	};

	// 선택된 필지
	selectedItem = (coordinate) => {
		//const { sisMap, sisLayer } = this.props.sis;
		const { sisLayer } = this.props.sis;

		const lyr = sisLayer.wfs.selectLayer;
		const source = lyr.getSource();
		const coord = transform(coordinate, "EPSG:5181", "EPSG:5186");

		let pnu;

		$.ajax({
			url: "/map/getJijukByCoordinate/",
			type: "post",
			async: false,
			data: {
				x: coord[0],
				y: coord[1],
			},
			success: (res) => {
				let addr = "";
				let addrToji = "";
				let jibun = "";

				if (res) {
					source.clear();
					pnu = res.pnu;
					const wkt = res.geom;

					const feature = sisLayer.createFeatureByWKT(wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					feature.setId(pnu);
					feature.setProperties(res);
					source.addFeature(feature);
					addr = res.sggNm + " " + res.emdNm + " " + (res.riNm ? res.riNm : "") + " " + res.jibun;
					addr = addr.slice(0, -1);
					addrToji = res.sggNm + " " + res.emdNm + " " + (res.riNm ? res.riNm : "");
					jibun = parseInt(res.bobn) + (parseInt(res.bubn) > 0 ? `-${parseInt(res.bubn)}` : "");

					this.selectRoadAddrByAddr(addr.replaceAll("  ", " "));

					// sisMap.view.fit(feature.getGeometry().getExtent());

					this.modal.show();
				} else {
					addr = "촬영지역 정보가 없습니다.";
					alert("지번정보가 존재하지 않습니다.");
				}

				this.setState({
					addr,
					addrToji,
					jibun,
					pnu,
				});
			},
		});

		return pnu;
	};

	getLaw = (ucode) => {
		$("#laws").html("");

		// 토지이용규제정보서비스 가져오기
		$.ajax({
			url: "/map/prop/GetBLLawView",
			data: {
				pnu: this.state.pnu,
				ucode,
			},
			success: (res) => {
				const xml = $.parseXML(res[0].result);

				if ($(xml).find("response").length !== 0) {
					if ($(xml).find("RG_DESC").length !== 0) {
						var rgdesc = $(xml).find("RG_DESC").text();

						if (rgdesc !== "") {
							$("#laws").html(rgdesc);
						} else {
							let str = "";
							str += "<table border='0' cellpadding='0' cellspacing='0' width='100%' height='100%'>";
							str += "<tr>";
							str += "<td align='center'><b>토지이용규제정보</b>가 존재하지 않습니다.</td>";
							str += "</tr>";
							str += "</table>";
							$("#laws").html(str);
						}
					} else {
						let str = "";
						str += "<table border='0' cellpadding='0' cellspacing='0' width='100%' height='100%'>";
						str += "<tr>";
						str += "<td align='center'><b>토지이용규제정보</b>가 존재하지 않습니다.</td>";
						str += "</tr>";
						str += "</table>";
						$("#laws").html(str);
					}
				}

				this.setState({
					laws: res ? res[0].result : "",
				});
			},
		});
	};

	numberWithCommas = (x) => {
		if (x.indexOf(".") > -1) {
			let arr = x.split(".");

			if (arr.length > 0) {
				let num = x.split(".")[0];
				let float = x.split(".")[1];
				// console.log(x);
				return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (float ? "." + float : "");
			}
		} else {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	};

	// 지번주소로 도로명주소 찾기
	selectRoadAddrByAddr = (addr) => {
		var self = this;

		// 도로명주소 찾기
		$.ajax({
			url: "https://business.juso.go.kr/addrlink/addrLinkApiJsonp.do", //인터넷망
			type: "post",
			data: {
				currentPage: 1,
				countPerPage: 10,
				resultType: "json",
				confmKey: "U01TX0FVVEgyMDI2MDcyODEwMjkwNDExOTg0NDM=",
				keyword: addr,
			},
			async: false,
			dataType: "jsonp",
			crossDomain: true,
			success: function (jsonStr) {
				var errCode = jsonStr.results.common.errorCode;
				var errDesc = jsonStr.results.common.errorMessage;
				if (errCode !== "0") {
					alert(errCode + "=" + errDesc);
				} else {
					if (jsonStr != null) {
						if (jsonStr.results.juso.length > 0) {
							var roadAddr = jsonStr.results.juso[0].roadAddr;

							self.setState({
								roadAddr: roadAddr.replace("전남광주통합특별시 ", ""),
							});
						} else {
							self.setState({
								roadAddr: "-",
							});
						}
					}
				}
			},
		});
	};

	// 지적도로 이동
	selectJijukByCode = (code) => {
		const { sisLayer, sisMap } = this.props.sis;

		const lyr = sisLayer.wfs.selectLayer;
		const source = lyr.getSource();

		let pnu;

		$.ajax({
			url: "/map/getJijukByPnu",
			type: "post",
			async: false,
			data: {
				code,
			},
			success: (res) => {
				if (res) {
					let addr = "";
					let addrToji = "";
					let jibun = "";

					if (res) {
						source.clear();
						pnu = res.pnu;
						const wkt = res.geom;

						const feature = sisLayer.createFeatureByWKT(wkt);
						feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
						feature.setId(pnu);
						feature.setProperties(res);
						source.addFeature(feature);
						addr = res.sggNm + " " + res.emdNm + " " + (res.riNm ? res.riNm : "") + " " + res.jibun;
						addr = addr.slice(0, -1);
						addrToji = res.sggNm + " " + res.emdNm + " " + (res.riNm ? res.riNm : "");
						jibun = parseInt(res.bobn) + (parseInt(res.bubn) > 0 ? `-${parseInt(res.bubn)}` : "");

						this.selectRoadAddrByAddr(addr);

						sisMap.view.fit(feature.getGeometry().getExtent());
						sisMap.view.setZoom(11);

						this.modal.show();
					} else {
						addr = "촬영지역 정보가 없습니다.";
					}

					this.setState({
						addr,
						addrToji,
						jibun,
						pnu,
					});
				} else {
					alert("지번정보가 존재하지 않습니다.");
					//window.location.href = "/main";
				}
			},
		});
	};

	componentDidMount() {
		const { LayoutActions } = this.props;

		LayoutActions.setModal({
			id: "mapInfoModal",
			target: this,
		});

		setTimeout(() => {
			if (this.props.sis.pnu.pnu) {
				this.show([], this.props.sis.pnu.pnu, this.props.sis.pnu, true);
			}
		}, 100);
	}

	render() {
		//const { toji, building, landUsePlan, individualPrice, individualHousePrice, publicToji, publicDaebu, publicHistory, publicBuilding } = this.state;
		const { toji, building, landUsePlan, individualPrice, individualHousePrice } = this.state;

		//const cnt = landUsePlan.length;

		// const test = [
		// 	{ name: "국토의계획및이용에관한법률", UCODE: 1, UNAME: "주소1", LAWNM: 25 },
		// 	{ name: "국토의계획및이용에관한법률", UCODE: 1, UNAME: "주소2", LAWNM: 26 },
		// 	{ name: "B", UCODE: 1, UNAME: "주소3", LAWNM: 27 },
		// 	{ name: "B", UCODE: 1, UNAME: "주소4", LAWNM: 28 },
		// 	{ name: "B", UCODE: 1, UNAME: "주소5", LAWNM: 29 },
		// ];

		// let aa = lodash
		// 	.chain(test)
		// 	.groupBy("name")
		// 	.map((data, key) => {
		// 		return { key, data };
		// 	})
		// 	.value();

		// 토지이용계획 관련법률
		//let lawGroupBy = lodash
		//	.chain(landUsePlan)
		//	.groupBy("LAWNM")
		//	.map((data, key) => {
		//		return { key, data };
		//	})
		//	.value();

		let mainLaws = [];

		landUsePlan.forEach((item) => {
			if (item.LAWNM === "국토의계획및이용에관한법률") mainLaws.push(item);
		});

		let subLaws = [];

		landUsePlan.forEach((item) => {
			if (item.LAWNM !== "국토의계획및이용에관한법률") subLaws.push(item);
		});

		const mainCnt = mainLaws.length;
		const subCnt = subLaws.length;

		const contents = (
			<div className={stl.contentWrapper}>
				<div className={stl.contentHeader}>
					<div className={`${stl.contentTab} ${this.state.tabCondition[0] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("0")}>
						토지대장
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[1] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("1")}>
						건축물 대장
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[2] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("2")}>
						토지이용계획
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[3] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("3")}>
						개별공시지가
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[4] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("4")}>
						개별주택가격
					</div>
				</div>
				<div className={`${stl.contentHeader} ${stl.mContentHeader}`}>
					<div className={`${stl.contentTab} ${this.state.tabCondition[0] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("0")}>
						토지
						<br />
						대장
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[1] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("1")}>
						건축물
						<br />
						대장
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[2] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("2")}>
						토지이용
						<br />
						계획
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[3] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("3")}>
						개별공시
						<br />
						지가
					</div>
					<div className={`${stl.contentTab} ${this.state.tabCondition[4] ? stl.active : stl.none}`} onClick={() => this.handleTabMove("4")}>
						개별주택
						<br />
						가격
					</div>
				</div>
				<div className={stl.contentBody}>
					<div className={stl.addrWrap}>
						<span className={stl.title} style={{ height: "40px", lineHeight: "30px" }}>
							주소
						</span>
						<span className={stl.addr} style={{ verticalAlign: "top" }}>
							{this.state.addr}
							<br />
							{this.state.roadAddr}
						</span>
					</div>

					{/* 토지대장 */}
					<div className={`${stl.tabContent} ${this.state.tabCondition[0] ? stl.active : stl.none}`}>
						<table>
							<caption>토지대장</caption>
							<tbody>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l25}`}>공부지목</th>
									<th className={`${stl.leftHeader} ${stl.l25}`}>면적(㎡)</th>
									<th className={`${stl.rightHeader} ${stl.l50}`} colSpan="2">
										토지이동(변동)사유
									</th>
								</tr>
								<tr>
									<td>{toji.JIMOK_NM ? toji.JIMOK_NM : "-"}</td>
									<td>{toji.PAREA ? this.numberWithCommas(toji.PAREA) : "-"}</td>
									<td colSpan="2">{toji.LAND_MOV_RSN_CD_NM ? toji.LAND_MOV_RSN_CD_NM : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l25}`}>소유권변동일자</th>
									<th className={`${stl.leftHeader} ${stl.l25}`}>소유구분</th>
									<th className={`${stl.rightHeader} ${stl.l25}`} colSpan="2">
										소유권변동원인
									</th>
									{/* <th className={`${stl.rightHeader} ${stl.l25}`}>소재지</th> */}
								</tr>
								<tr>
									<td>{toji.OWNDYMD}</td>
									<td>{toji.OWN_GBN_NM}</td>
									<td colSpan="2">{toji.OWN_RGT_CHG_RSN_CD_NM}</td>
									{/* <td>{this.state.addr}</td> */}
								</tr>
							</tbody>
						</table>

						<table style={{ marginTop: "20px" }}>
							<caption>토지이동사유</caption>
							<tbody>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>토지이동일</th>
									<th className={`${stl.rightHeader} ${stl.l50}`}>토지이동사유</th>
								</tr>
								<tr>
									<td>{toji.LAND_MOV_YMD}</td>
									<td>{toji.LAND_MOV_RSN_CD_NM}</td>
								</tr>
							</tbody>
						</table>
					</div>

					{/* 건축물 대장 */}
					<div className={`${stl.tabContent} ${this.state.tabCondition[1] ? stl.active : stl.none}`}>
						<table className={stl.tbl}>
							<caption>건축물대장</caption>
							<tbody>
								<tr className={stl.cnt3}>
									<th>대지위치</th>
									<th>지목</th>
									<th>총대지면적(㎡)</th>
								</tr>
								<tr>
									<td>{building.LAND_LOC_NM ? building.LAND_LOC_NM : "-"}</td>
									<td>{toji.JIMOK_NM ? toji.JIMOK_NM : "-"}</td>
									<td>{building.LAREA ? this.numberWithCommas(building.LAREA) : "-"}</td>
								</tr>

								<tr className={stl.cnt3}>
									<th>건축물명칭</th>
									<th>동명칭/번호</th>
									<th>연면적(㎡)</th>
								</tr>
								<tr>
									<td>{building.BLDG_NM ? building.BLDG_NM : "-"}</td>
									<td>{building.DONG ? building.DONG : "-"}</td>
									<td>{building.GAREA ? this.numberWithCommas(building.GAREA) : "-"}</td>
								</tr>
							</tbody>
						</table>

						<span className={stl.tblTitle}>건축물정보</span>
						<table className={stl.tbl}>
							<caption>건축물정보</caption>
							<tbody>
								<tr className={stl.cnt6}>
									<th>대지면적</th>
									<th style={{ padding: "0 10px" }}>건축면적</th>
									<th>연면적</th>
									<th>건폐율</th>
									<th>용적률</th>
									<th>지상층수</th>
								</tr>
								<tr>
									<td>{building.LAREA ? this.numberWithCommas(building.LAREA) : "-"}</td>
									<td>{building.BAREA ? this.numberWithCommas(building.BAREA) : "-"}</td>
									<td>{building.GAREA ? this.numberWithCommas(building.GAREA) : "-"}</td>
									<td>{building.BLR ? building.BLR : "-"}</td>
									<td>{building.FSI ? building.FSI : "-"}</td>
									<td>{building.UFLR ? building.UFLR : "-"}</td>
								</tr>

								<tr className={stl.cnt6}>
									<th>주용도</th>
									<th>주구조</th>
									<th>부속건축물</th>
									<th>사용승인일자</th>
									<th>기타건축물명</th>
									<th>지하층수</th>
								</tr>
								<tr>
									<td>{building.MAIN_USE_NM ? building.MAIN_USE_NM : "-"}</td>
									<td>{building.STRU_NM ? building.STRU_NM : "-"}</td>
									<td>{building.MAIN_SUB_GBN_NM ? building.MAIN_SUB_GBN_NM : "-"}</td>
									<td>{building.USE_APRV_YMD ? building.USE_APRV_YMD : "-"}</td>
									<td>{building.KM_NAME ? building.KM_NAME : "-"}</td>
									<td>{building.BFLR ? building.BFLR : "-"}</td>
								</tr>

								<tr className={stl.cnt6}>
									<th colSpan="2">위반건축물 여부</th>
									<th colSpan="4">변경일자</th>
								</tr>
								<tr>
									<td colSpan="2">{building.VIO_BLDG_YN ? building.VIO_BLDG_YN : "-"}</td>
									<td colSpan="4">{building.REGIST_DAY ? building.REGIST_DAY : "-"}</td>
								</tr>
							</tbody>
						</table>

						{/* <span className={stl.tblTitle}>주차장</span>
						<table className={stl.tbl}>
							<tbody>
								<tr className={stl.cnt4}>
									<th>주차수</th>
									<td>-</td>
									<th>주차장면적</th>
									<td>-</td>
								</tr>
							</tbody>
						</table>

						<span className={stl.tblTitle}>승강기</span>
						<table className={stl.tbl}>
							<tbody>
								<tr className={stl.cnt4}>
									<th>승용</th>
									<td>-</td>
									<th>비상용</th>
									<td>-</td>
								</tr>
							</tbody>
						</table> */}
					</div>

					{/* 토지이용계획 */}
					<div className={`${stl.tabContent} ${this.state.tabCondition[2] ? stl.active : stl.none}`}>
						<span className={stl.tblTitle}>토지이용계획</span>
						<table className={stl.tbl}>
							<caption>토지이용계획</caption>
							<tbody>
								<tr>
									<th rowSpan="2" style={{ width: "16.666%" }}>
										발급승인여부
									</th>
									<th style={{ width: "33%" }}>「국토의 계획 및 이용에 관한 법률」에 따른 지역, 지구 등</th>
									<td style={{ width: "50%" }}>
										{/* 국토계획 이용에 관한법률 전부 여기 나머진 아래쪽 */}
										{mainLaws.map((law, idx) => {
											if (law.LAWNM === "국토의계획및이용에관한법률")
												if (idx === mainCnt - 1)
													return (
														<a key={idx} style={{ cursor: "pointer" }} onClick={() => this.getLaw(law.UCODE)}>
															{law.UNM}
														</a>
													);
												else
													return (
														<a key={idx} style={{ cursor: "pointer" }} onClick={() => this.getLaw(law.UCODE)}>
															{law.UNM},{" "}
														</a>
													);
											else return null;
										})}
									</td>
								</tr>
								<tr>
									<th style={{ width: "200px" }}>다른법령등에 따른 지역, 지구등</th>
									<td style={{ width: "50%" }}>
										{/* 나머지 */}
										{subLaws.map((law, idx) => {
											if (law.LAWNM !== "국토의계획및이용에관한법률")
												if (idx === subCnt - 1)
													return (
														<a key={idx} style={{ cursor: "pointer" }} onClick={() => this.getLaw(law.UCODE)}>
															{law.UNM}
															{"<"}
															{law.LAWNM}
															{">"}
														</a>
													);
												else
													return (
														<a key={idx} style={{ cursor: "pointer" }} onClick={() => this.getLaw(law.UCODE)}>
															{law.UNM}
															{"<"}
															{law.LAWNM}
															{">"},{" "}
														</a>
													);
											else return null;
										})}
									</td>
								</tr>
							</tbody>
						</table>

						<span className={stl.tblTitle}>지역, 지구등 안에서의 행위제한내용</span>
						<table>
							<caption>토지이용규제정보</caption>
							<tbody>
								<tr>
									<td id="laws" style={{ textAlign: "left", paddingLeft: "10px" }}>
										<table border="0" cellPadding="0" cellSpacing="0" width="100%" height="100%">
											<tbody>
												<tr>
													<td align="center">
														<b>토지이용규제정보</b>가 존재하지 않습니다.
													</td>
												</tr>
											</tbody>
										</table>
										{/* <span style={{ fontWeight: "bold" }}>택지개발지구</span>
										<br />
										&nbsp;<a href="#">택지개발촉진법</a> 제6조
										<br />
										&nbsp;<a href="#">택지개발촉진법 시행령</a> 제6조 */}
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					{/* 개별공시지가 */}
					<div className={`${stl.tabContent} ${this.state.tabCondition[3] ? stl.active : stl.none}`}>
						<table className={stl.tbl}>
							<caption>개별공시지가</caption>
							<thead>
								<tr>
									<th colSpan="3">신청대장 토지</th>
									<th colSpan="3">확인내용</th>
								</tr>
								<tr>
									<th>가격기준년도</th>
									<th>토지소재지</th>
									<th>지번</th>
									<th>개별공시지가(원)</th>
									<th>기준일자</th>
									<th>공시일자</th>
								</tr>
							</thead>
							<tbody>
								{individualPrice.slice().reverse().map((item, idx) => {
									return (
										<tr key={idx}>
											<td>{item.stdrYear ? item.stdrYear : "-"}</td>
											<td>{this.state.addrToji}</td>
											<td>{this.state.jibun}</td>
											<td>{item.pblntfPclnd ? this.numberWithCommas(item.pblntfPclnd) : "-"}</td>
											<td>{item.stdrYear}-{item.stdrMt}</td>
											<td>{item.pblntfDe ? item.pblntfDe : "-"}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>

					{/* 개별주택가격 */}
					<div className={`${stl.tabContent} ${this.state.tabCondition[4] ? stl.active : stl.none}`}>
						<table className={stl.tbl}>
							<caption>개별주택가격</caption>
							<thead>
								<tr>
									<th rowSpan="2">
										가격기준연도
										<br />
										(기준일)
									</th>
									{/* <th rowSpan="2">건물번호</th> */}
									<th rowSpan="2">주택소재지</th>
									<th colSpan="2">대지면적(㎡)</th>
									<th colSpan="2">건물연면적(㎡)</th>
									<th rowSpan="2">
										개별주택가격
										<br />
										(원)
									</th>
								</tr>
								<tr>
									<th>전체</th>
									<th>산정</th>
									<th>전체</th>
									<th>산정</th>
								</tr>
							</thead>
							<tbody>
								{individualHousePrice.slice().reverse().map((item, idx) => {
									return (
										<tr key={idx} >
											<td>{item.stdrYear}-{item.stdrMt}</td>
											{/* <td>{item.DONG_NO ? item.DONG_NO : "-"}</td> */}
											<td>{this.state.addr}</td>
											<td>{item.ladRegstrAr ? item.ladRegstrAr : "-"}</td>
											<td>{item.calcPlotAr ? item.calcPlotAr : "-"}</td>
											<td>{item.buldAllTotAr ? item.buldAllTotAr : "-"}</td>
											<td>{item.buldCalcTotAr ? item.buldCalcTotAr : "-"}</td>
											<td>{item.housePc ? this.numberWithCommas(item.housePc) : "-"}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);

		return (
			<div>
				<SisModal
					id={this.props.id}
					ref={(ref) => (this.modal = ref)}
					className={stl.mapInfoModal}
					draggable
					title="정보보기"
					closeEvent={() => {
						this.handleTabMove("0");
					}}
					contents={contents}
				/>
			</div>
		);
	}
}

function show_detail(selectObject) {
	var obj = document.getElementsByName("ArService");

	var obj2 = document.getElementsByName("ArService_law");

	for (let i = 0; i < obj.length; i++) {
		if (selectObject == obj[i]) {
			if (obj2[i].style.display == "block") {
				obj2[i].style.display = "none";
			} else {
				obj2[i].style.display = "block";
			}
		}

		//parent.getReSize();
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(MapInfoModal);
